import * as React from 'react';
import createSvgIcon from './utils/createSvgIcon';
export default createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M20 4H4v16h16V4zm-2 14H6V6h12v12z"
}), 'CropSquareSharp');


//////////////////
// WEBPACK FOOTER
// ./~/@material-ui/icons/esm/CropSquareSharp.js
// module id = 3040
// module chunks = 2